(ns frontend.view.modals.delete-confirmation.model
  (:require [potpuri.core :as potpuri]))

(def root-path [::state])

(def loading?-path [:loading?])
(def loading?-full-path (into root-path loading?-path))

(def entity-id-path [:entity-id])
(def entity-id-full-path (into root-path entity-id-path))

(def conflicts-path [:conflicts])
(def conflicts-full-path (into root-path conflicts-path))

(def confirmed?-path [:confirmed?])
(def confirmed?-full-path (into root-path confirmed?-path))

(def processing?-path [:processing?])
(def processing?-full-path (into root-path processing?-path))

(def error-path [:error])
(def error-full-path (into root-path error-path))

(defn cleanup
  [db]
  (potpuri/dissoc-in db root-path))

(defn start-loading
  [db entity-id]
  (-> db
      (assoc-in loading?-full-path true)
      (assoc-in entity-id-full-path entity-id)))

(defn set-conflicts
  [db conflicts]
  (-> db
      (assoc-in loading?-full-path false)
      (assoc-in conflicts-full-path conflicts)))

(defn set-error
  [db error]
  (-> db
      (assoc-in loading?-full-path false)
      (assoc-in error-full-path error)))

(defn set-confirmed
  [db v]
  (-> db
      (assoc-in confirmed?-full-path (boolean v))))

(defn start-processing?
  [db]
  (-> db
      (assoc-in processing?-full-path true)))





